module.exports = __webpack_public_path__ + "img/salle-de-bain.08af5619.svg";